

const AppConfig = {

    time: {
        displayTimezone: "America/Chicago",
        displayDateFormat: "MMMM D, YYYY",
        urlParamFormat: "MM/DD/YYYY",
        urlParamFormatOptional: "M/D/YYYY"
    },
    fuel: {
        light: 0,
        medium: 1,
        heavy: 2,
    },
    size: {
        small: 0,
        medium: 1,
        large: 2
    }
}

export default AppConfig;